import moment from 'moment';
import COVERAPP from './COVERAPP'
import CONFIG from './config'

let FILTER = {
    formatTime(time, str) {
        if(!time) return;
        if(str != 'week') {
            return moment(time).format(str);
        }
        let day =  moment(time).day();
        switch (day) {
            case 1:
                return '星期一'
            case 2:
                return '星期二'
            case 3:
                return '星期三'
            case 4:
                return '星期四'
            case 5:
                return '星期五'
            case 6:
                return '星期六'
            case 0:
                return '星期天'
        }
    },
    slimImageFilter(img, imgParamW, imgParamH) {
        return img + '?imageMogr2/thumbnail/!' + imgParamW + 'x' + imgParamH + 'r/gravity/Center/crop/' + imgParamW + 'x' + imgParamH + '|imageslim';
    },
    linkFilter(item) {
        if(COVERAPP.Attribute.isApp()) {
            let flag = parseInt(item.flag);
            let ulink = CONFIG.APP_SCHEME_URL;
            if (flag === 18) {
                ulink += `/news?id=${item.event_today.id}&flag=${flag}`;
            } else if (flag === 5 || flag === 13 || flag === 30 || flag == 36) {
                ulink += `/news?id=${item.subject_id}&flag=${flag}`;
            } else if(flag == 14) {
                return item.external_url;
            } else {
                ulink += `/news?id=${item.news_id}&flag=${flag}`;
            }
            return ulink;
        }
        let linklist = ['news_details.html', 'video_details.html', 'subject.html', 'live_casting.html', 'news_details_qm.html', 'event.html', 'live_forecast.html', 'new_video_details.html', 'audio_details.html'];
        // item.flag  0：无图，1：单图，2：多图，3：图集，4：视频(标示该新闻中有视频),5, 专题(专栏), 用于客户端标志详情页如何跳转 
        //            7:图文直播。 8：视频直播，9：视频图文直播， 10：外链，11：VR视频，12VR图片，13:专题(不可订阅) ，14:外链活动 ,15:封面号, 17 q
        //            30: 有分类的专题， 36：有分类的专栏， 40：5.0版本给app返回视频是40
        // item.external_url
        //给普通新闻和事件、专题、专栏加上频道id
       
        let type = parseInt(item.flag);
        let id = item.news_id;
        // 外链
        if (type === 10 || type === 14) {
            if(!COVERAPP.Attribute.isApp() && COVERAPP.Attribute.isIOS() && item.external_url.indexOf('zmt-m.hljtv.com') > -1) {
                let link = item.external_url.replace('zmt-m.hljtv.com', 'wapcdn.hljtv.com/cdn/wap');
                return link.indexOf('?') > -1 ? `${link}&version=${+new Date()}` : `${link}?version=${+new Date()}`;
            }
            return item.external_url;
        } else if (type === 7 || type === 9 || type === 19 || type === 21 || type === 22 || type === 24) {
            return CONFIG.WAP_ADDRESS + linklist[3] + '?news_id=' + id + '&version=new';
            // 视频页面
        } else if (type === 11 || type === 4 || type === 40 || type === 43) {
            return CONFIG.WAP_ADDRESS + linklist[1] + '?id=' + id;
            // 专题专栏
        } else if (type === 5 || type === 13 || type === 30 || type == 36) {
            return CONFIG.WAP_ADDRESS + linklist[2] + '?id=' + item.subject_id + '&channel_type=' + type;
            // 事件
        } else if (type === 18) {
            return CONFIG.WAP_ADDRESS + linklist[5] + '?event_id=' + item.event_today.id;
            // 直播预告
        } else if (type === 25 || type === 27) {
            return CONFIG.WAP_ADDRESS + linklist[6] + '?news_id=' + id;
            //音频页面
        } else if (type == 42) {
            return CONFIG.WAP_ADDRESS + linklist[8] + '?id=' + id;
        } else {
            return CONFIG.WAP_ADDRESS + linklist[0] + '?id=' + id;
        }
        
    }
}
export default FILTER = FILTER;